import { findElementByXPath, getUrlPath } from './utils/utils';

export class ReductionBase {
  constructor(props) {
    this.debugId = props.debugId;
    this.host = props.host;
    this.data = null;
    this.events = null;
    this.taskMap = {}; // key: 事件id，value：任务
    this.pendingRequest = [];
  }

  // 启动
  async init() {
    try {
      await this.fetchData(this.debugId);
      await this.taskScheduling();
    } catch (e) {
      console.log(e, '>>>>>>初始化失败');
    }
  }

  // 获取数据
  async fetchData() {
    // const res = await fetch(`http://monitor-server.test.b2c.srv/monitor/debug/detail`, {
    const res = await fetch(`${this.host}/monitor/debug/detail`, {
      method: 'post',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: this.debugId }),
    });
    const body = await res.json();
    if (body.code !== 0) {
      // todo: 终止
      throw new Error(body.msg || '数据获取失败');
    }
    this.data = body.data;
    this.events = this.data?.actions || [];
    console.log(this.events, '>>>>>>events');
    // 请求到数据后，将待执行的请求放入待执行任务队列中
    // 用于解决程序请求已经执行，但debug数据还没有获取到的情况
    this.pendingRequest.forEach((fn) => {
      fn();
    });
  }

  //
  dealyRequest(url, resolve) {
    // 通过url获取数据
    const target = this.events.find((item) => {
      if (item?.type === 'data' && getUrlPath(item?.info?.path) === getUrlPath(url) && !item.info?._status) {
        item.info._status = 'done';
        return true;
      }
      return false;
    });
    const duration = target?.info?.duration || 0;
    const res = {
      ...(target?.info?.response || {}),
      ok: target?.info?.response?.status === 200,
      json: () => {
        return target.info?.response?.body;
      },
    };
    console.log(duration, url, '>>>>>>duration api');
    // 将请求放入task中，当触发任务时，返回请求数据
    this.taskMap[target.id] = () => {
      setTimeout(() => {
        resolve(res);
        // todo: 使用duration 会出现问题
      }, 0); //
    };
  }

  // 模拟数据请求
  taskGetData(url) {
    return new Promise((resolve) => {
      // 如果数据还没有获取到，先将请求放入队列中
      if (!this.events) {
        this.pendingRequest.push(() => {
          this.dealyRequest(url, resolve);
        });
      } else {
        this.dealyRequest(url, resolve);
      }
    });
  }

  // 模拟点击行为
  taskTouch(event) {
    const tag = event?.info?.tag || '';
    const element = event?.info.isXpath
      ? findElementByXPath(tag)
      : document.querySelector(`[data-testid="${tag}"]`);
    if (element) {
      element.click();
    }
  }

  // 模拟滚动行为
  taskScroll(event) {
    const tag = event?.info?.tag || '';
    const element = event?.info.isXpath
      ? findElementByXPath(tag)
      : document.querySelector(`[data-testid="${tag}"]`);
    if (element) {
      element.scrollTo({
        top: event?.info?.offsetY,
        left: event?.info?.offsetX,
        behavior: 'smooth',
      });
    }
  }

  // 任务调度
  async taskScheduling(index = 0) {
    const target = this.events[index];
    // console.warn用于puppeteer截屏
    if (!target) { return console.warn('replay_end'); }
    // 如果不是数据请求、touch、scroll类型，直接执行下一个任务
    if (!['data', 'touch', 'scroll'].includes(target.type)) {
      return this.taskScheduling(index + 1);
    }
    // 获取当前任务的执行时间
    const preTime = index === 0 ? this.data.time : this.events[index - 1].time;
    const duration = target?.time - preTime;
    console.log(duration, target?.time, preTime, target?.name, '>>>>>>duration task');
    setTimeout(() => {
      console.log(target, target.type, duration, '>>>>>>target');
      if (target.type === 'data') {
        this.taskMap[target.id] && this.taskMap[target.id]();
      } else if (target.type === 'touch') {
        // console.warn用于puppeteer截屏
        console.warn(`screenshot__${target.id}`);
        this.taskTouch(target);
      } else if (target.type === 'scroll') {
        this.taskScroll(target);
        // console.warn用于puppeteer截屏
        // 需要计算出滚动时间，确保截屏时是滚动后的状态
        setTimeout(() => {
          console.warn(`screenshot__${target.id}`);
        }, target?.info?.duration || 0);
      }
      // 执行下一个任务
      this.taskScheduling(index + 1);
    }, duration);
  }
}
